import React from 'react'

import { Button, Modal, ModalInjectedProps } from '@sketch/components'

import { useToast } from '@sketch/toasts'
import { useUnlinkSocialAccountMutation } from '@sketch/gql-types'
import { getSocialProviderFromToken, useSignOut } from '@sketch/modules-common'

// eslint-disable-next-line no-restricted-imports
import { SocialSignInProvider } from '@sketch/gql-types/expansive'

interface ConfirmSocialProviderRemoveModalProps extends ModalInjectedProps {
  identifier: string
  provider: SocialSignInProvider
}

export const ConfirmSocialProviderRemoveModal: React.FCC<
  ConfirmSocialProviderRemoveModalProps
> = ({ identifier, provider, hideModal }) => {
  const { showToast } = useToast()
  const signOut = useSignOut()

  const currentSignInProvider = getSocialProviderFromToken()
  const isCurrentProvider = provider === currentSignInProvider

  const [unlinkSocialAccountMutation, { loading }] =
    useUnlinkSocialAccountMutation({
      onCompleted: () => {
        hideModal()
        showToast('Social account removed successfully', 'positive')

        if (isCurrentProvider) {
          signOut()
        }
      },
      onError: 'show-toast',
    })

  const onClick = () => {
    unlinkSocialAccountMutation({
      variables: { identifier },
    })
  }

  return (
    <Modal title="Are you sure?" onCancel={hideModal}>
      <Modal.Body>
        {isCurrentProvider ? (
          <>
            Removing this sign in method will sign you out of Sketch.
            You&apos;ll need to sign in again using another sign in method.
          </>
        ) : (
          <>
            If you remove this sign in method, you will no longer be able to use
            it to access your Sketch account.
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={loading} onClick={hideModal}>
          Cancel
        </Button>
        <Button
          type="submit"
          variant="negative"
          loading={loading}
          onClick={onClick}
        >
          Remove
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmSocialProviderRemoveModal
